<template>
  <div>
    <el-cascader :props="props" clearable placeholder="请选择地址" v-model="value" :options="options" size="mini"
      @change="handleChange"></el-cascader>

  </div>
</template>



<script>
import { addressUrl } from '../../utils/global'
import axios from 'axios'
import Qs from 'qs'
let list
let id = 0
export default {
  props: ["msg"],
  data() {
    return {
      value: [],
      options: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          list = JSON.parse(sessionStorage.getItem("list"))
          const { level } = node;
          let pams = '';
          let n = 0;
          let l = level;


          if (list.country) {
            n = 0
            pams = list.country.split(",")[0]
            l = level + 3
          } else {

            if (list.city) {
              l = level + 2
              n = 0
              pams = list.city.split(",")[0]
            } else {

              if (list.province) {
                l = level + 1
                n = 1
                pams = list.province.split(",")[0]
              } else {
                n = 2
              }
            }
          }



          if (l == 0) {
            axios.post(addressUrl + "/query/province").then(function (res) {
              let provinceList = res.data.result
              let nodeArr = []
              for (let i in provinceList) {
                nodeArr.push({
                  value: provinceList[i]['provice_id'] + "," + provinceList[i]['provice_name'],
                  label: provinceList[i]['provice_name'],
                  leaf: level >= n
                })
              }
              const nodes = nodeArr
              resolve(nodes);
            }).catch(function () {

            })
          } else if (l == 1) {
            let params = {
              provice_id: node.data ? node.data.value.split(",")[0] : pams,
              //  provice_name:node.data.label
            }
            axios.post(addressUrl + "/query/city", Qs.stringify(params), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
              },
            }).then(function (res) {
              let provinceList = res.data.result
              let nodeArr = []
              for (let i in provinceList) {
                nodeArr.push({
                  value: provinceList[i].city_id + "," + provinceList[i].city_name,
                  label: provinceList[i].city_name,
                  leaf: level >= n
                })
              }
              const nodes = nodeArr
              resolve(nodes);
            }).catch(function () {

            })
          } else if (l == 2) {
            let params = {
              city_id: node.data ? node.data.value.split(",")[0] : pams,
            }
            axios.post(addressUrl + "/query/county", Qs.stringify(params), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
              },
            }).then(function (res) {
              let provinceList = res.data.result
              let nodeArr = []
              for (let i in provinceList) {
                nodeArr.push({
                  value: provinceList[i].county_id + "," + provinceList[i].county_name,
                  label: provinceList[i].county_name,
                  leaf: level >= n
                })
              }
              const nodes = nodeArr
              resolve(nodes);
            }).catch(function () {

            })
          }
        }
      }
    };


  },
  watch: {
    msg() {
      // this.value="";
      // console.log(123)
      this.$emit('childByValue', this.value)
    }
  },
  methods: {
    handleChange(value) {

      let avv;
      let bvv;
      avv = value
      if (list.village) {
        avv = [list.province, list.city, list.country, list.town, list.village]
      } else {
        if (list.town) {
          let a = [list.province, list.city, list.country, list.town]
          avv = a.concat(value)
        } else {
          if (list.country) {
            let a = [list.province, list.city, list.country]
            avv = a.concat(value)
          } else {
            if (list.city) {
              let a = [list.province, list.city]
              avv = a.concat(value)
            } else {
              if (list.province) {
                let a = [list.province]
                avv = a.concat(value)

              }
            }
          }
        }
      }

      this.$emit('childByValue', avv)
    },

  },
  mounted() {

    this.handleChange("")
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Core/authCode.vue